"use strict";
if (!fetch) require('whatwg-fetch');
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Croppie from 'croppie';
import _ from 'lodash';
import 'croppie/croppie.css';
// import './style.css';

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export default class ImageCropper extends Component {

  static propTypes = {
    filename: PropTypes.string,
    height: PropTypes.number,
    uploadText: PropTypes.string,
    onUploaded: PropTypes.func,
    imageUploaded: PropTypes.bool,
    croppedHeight: PropTypes.number,
    croppedWidth: PropTypes.number,
    width: PropTypes.number,
    backgroundColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    onError: PropTypes.func
  };

  static defaultProps = {
    filename: null,
    height: 200,
    onUploaded: () => {},
    maxFileSize: 5,
    uploadText: 'Upload Image',
    imageLoaded: false,
    imageUploaded: false,
    croppedHeight: 200,
    croppedWidth: 200,
    backgroundColor: 'grey',
    backgroundImage: '/system/fundraisers/cover_photos/000/000/002/large/avatar.png',
    width: 200,
    onError: () => {}
  };

  state = {
    base64Image: null,
    filename: null,
    location: null
  }

  constructor(props){
    super(props);

    console.log("croppedWidth: ");
    console.log(this.props.croppedWidth);
    console.log("croppedHeight: ");
    console.log(this.props.croppedHeight);

    this.rotateLeft = this.rotateLeft.bind(this);
    this.rotateRight = this.rotateRight.bind(this);
    this.cropAndUpload = this.cropAndUpload.bind(this);
    this.loadFile = this.loadFile.bind(this);
    this.loadButtonChanged = this.loadButtonChanged.bind(this);
    this.reset = this.reset.bind(this)
    this.mobileCheck = this.mobileCheck.bind(this)
  }

  mobileCheck(){
    var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
  }

  componentDidMount() {
    this.setState({backgroundImage: this.props.backgroundImage});
    this.setState({uploadText: this.props.uploadText });
    this.croppieObj = new Croppie(this.croppieElement, {
      boundary: {
        height: this.props.croppedHeight + 200,
        width: this.props.croppedWidth + 200,
      },
      viewport: {
        height: this.props.croppedHeight,
        width: this.props.croppedWidth,
        type: this.props.type
      },
      enableOrientation: true,
      showZoomer: true
    });
}

  componentWillUpdate(nextProps, nextState){
    if (this.state.base64Image != nextState.base64Image){
        if (nextState.base64Image != null) {
          this.croppieObj.bind({
            url: nextState.base64Image
          }, () => this.mobileCheck() ? this.cropAndUpload(null) : null );
        }
    }
  }

  reset() {
    this.setState({filename: null, location: null, imageLoaded: false});
  }

  uploadToServer(file) {
    this.reset();
    this.setState({currentlyUploading: true});
    var me = this;
    var Promise = require('promise');
    var uploadPromise = Promise.denodeify(this.props.onUploaded)
      uploadPromise(file, this.state.filename).then(function (res) {
      me.setState({currentlyUploading: false,
                  uploadText: "Change Image",
                  imageUploaded: true,
                  backgroundImage: res.data.image_url,
                  imageLoaded: false});
    });
  }

  rotateLeft() {
    this.croppieObj.bind({url: this.state.base64Image, orientation: 8});
    e.preventDefault();
    return false;
  }

  rotateRight(e) {
    this.croppieObj.bind({url: this.state.base64Image, orientation: 6});
    e.preventDefault();
    return false;
  }

  loadFile() {
    this.setState({'base64Image': null});
    this.loadButton.click();
  }

  async loadButtonChanged(e) {

    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      if ((!file.type.match(/^image\//)) || (!file.type.match(/jpeg|jpg|png/)) ) {
        this.handleError(new Error(`${file.type} is an invalid image type`));
        return;
      }
      if (file.size > (this.props.maxFileSize * 1000000)) {
        this.handleError(new Error(`This file exceeds the maximum file size of ${this.props.maxFileSize} MB.`));
        return;
      }
      const matches = e.target.value.match(/\\[^\\]+\.[^\\]+$/g);
      let filename = guid();
      if (this.props.filename) {
        filename = this.props.filename;
      } else if (matches.length > 0) {
        filename = matches[0].replace('\\', '');
      }
      if (this.props.subfolder) filename = `${this.props.subfolder}/${filename}`.replace(/\/\//g, '/');
      this.setState({'base64Image': await this.blobToBase64(file),
        'filename': guid() + filename,
        'imageLoaded': true });

      //
      // if (this.mobileCheck()){
      //   this.cropAndUpload(null);
      // }
    }
  }

  async blobToBase64(file) {
    return new Promise((resolve, reject) => {
      if (file instanceof Blob) {
        var fileReader = new FileReader();
        fileReader.onload = function(e) {
          return resolve(e.target.result);
        };
        fileReader.readAsDataURL(file);
      } else {
        return reject(new Error('Not an instance of Blob'));
      }
    });
  }

  handleError(err) {
    alert(err.message);
    this.props.onError(err);
  }

  async base64ToBlob(base64) {
    return fetch(base64).then(res => res.blob());
  }

  async cropAndUpload(e = null) {
    if (e){
      e.preventDefault();
    }
    const file = await this.croppieObj.result({type: 'blob'});
    const body = await this.uploadToServer(file);
  }


  render() {
    var additionHeight;
    if (this.props.actualSize){
      additionHeight = 110
    }
    else {
      additionHeight = 200
    }


     if (this.state.imageLoaded) {
      return (
        <div id="react-croppable-s3" style={{
          height: this.props.height + 300 + this.mobileCheck() ? -this.props.mobileHeightCompensation : 0,
          width: "100%",
          textAlign: 'center'
        }}>
          <input ref={(input) => { this.loadButton = input; }} type="file" onChange={this.loadButtonChanged} hidden />
          <div ref={(input) => { this.croppieElement = input; }} style={{display: this.state.imageLoaded ? 'inline' : 'none'}}></div>
        <div style={{
          display: 'flex',
          justifyContent: 'center'
        }}>
        <div className="btn cancel" style={{backgroundColor: "#c7c7c7"}} onClick={this.reset}>Cancel</div>
        <div className='rotation-buttons'>
          <button className="rotate"  onClick={this.rotateRight}>Rotate Right</button>
          <button className="reset"  onClick={this.rotateLeft}>Rotate Left</button>
        </div>
        <div className="btn save" style={{marginLeft: 40}} onClick={this.cropAndUpload}>Save</div>
      </div>
      </div>
    );
    }
    else if (this.state.currentlyUploading){
      return (
        <div id="react-croppable-s3" style={{
          height: this.props.height + 300 + this.mobileCheck() ? -this.props.mobileHeightCompensation : 0,
          width: "100%",
          textAlign: 'center'
        }}>
          <input ref={(input) => { this.loadButton = input; }} type="file" onChange={this.loadButtonChanged} hidden />
          <div ref={(input) => { this.croppieElement = input; }} style={{display: this.state.imageLoaded ? 'inline' : 'none'}}></div>
          <div >
            Uploading Image...
          </div>
        </div>
      )
    }
    else {
      return (
        <div id="react-croppable-s3" style={{
          height: this.props.height + additionHeight + this.mobileCheck() ? -this.props.mobileHeightCompensation : 0,
          width: "100%",
          textAlign: 'center'
        }}>
          <input ref={(input) => { this.loadButton = input; }} type="file" onChange={this.loadButtonChanged} hidden />
          <div ref={(input) => { this.croppieElement = input; }} style={{display: this.state.imageLoaded ? 'inline' : 'none'}}></div>
          <div onClick={this.loadFile} style={{
                        height: this.props.height + this.mobileCheck() ? -this.props.mobileHeightCompensation : 0,
                        width: "100%",
                        cursor: 'pointer'
                      }}>
                      {this.props.children ? this.props.children : (<div style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPositionX: 'center'
                      }}>
                      { this.props.actualSize &&
                          <img src={this.state.backgroundImage} className="image-cropper-pre" />
                      }
                      { !this.props.actualSize &&
                        <img src={this.state.backgroundImage} className="image-cropper-pre" style={{width:this.props.displayWidth, height: this.props.displayHeight}}/>
                      }
                      <div></div>
                      <div className="btn waves-effect">
                        {this.state.uploadText}
                      </div>
                      <div style={{fontSize: 10, marginTop: 10, marginBottom: 10}}>
                        Upload a .jpg, .jpeg, .png smaller than {this.props.maxFileSize} MB.
                      </div>
                      <div style={{fontSize: 10, marginTop: 10, marginBottom: 10}}>
                        Recommended size: {this.props.croppedWidth} W x {this.props.croppedHeight} H
                      </div>
                    </div>)}
                  </div>
        </div>
      );
    }
  }



}
